import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from './ToastContext';

// Hide the iOS WKWebView "previous / next / Done" input accessory bar
// above the keyboard. Resolves on iOS native; web + Android silently
// no-op. Dynamic import so a missing plugin in a sandbox build doesn't
// crash the bundle.
(async () => {
  try {
    const mod = await import('@capacitor/keyboard');
    if (mod?.Keyboard?.setAccessoryBarVisible) {
      await mod.Keyboard.setAccessoryBarVisible({ isVisible: false });
    }
  } catch {}
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
